import { ITaskModel } from '../../../../../shared/interfaces/task-model.interface';
import { Component, Input } from '@angular/core';

import { getPrettyPropertyRecordCalculationStatus, TaskType } from '../../../../../shared/enums';

import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-process-details-view',
    templateUrl: './process-details-view.component.html',
    styleUrls: ['./process-details-view.component.scss']
})
export class ProcessDetailsViewComponent {
    getPrettyPropertyRecordCalculationStatus;

    constructor() {
        this.getPrettyPropertyRecordCalculationStatus = getPrettyPropertyRecordCalculationStatus;
    }

    get showDataSourceCategories(): boolean {
        return (
            [
                TaskType.SYNC_ZONING_CODE_SOLR_DATA,
                TaskType.REMOVE_ZONING_CODE_SOLR_DATA,
                TaskType.SYNC_ZC_PRS_JOB,
                TaskType.ZONING_CODE_INDEXING_WITH_CURSOR,
                TaskType.COLLECT_TILES_DATA,
                TaskType.CALCULATE_FOLIOS_MULTI_THREAD,
                TaskType.CREATE_PRS_LIST_BY_STATUS_PROCESS
            ].indexOf(this.task.type) >= 0
        );
    }

    get showSaveRawIds(): boolean {
        return [TaskType.SYNC_ZC_PRS_JOB, TaskType.ZONING_CODE_INDEXING_WITH_CURSOR].indexOf(this.task.type) >= 0;
    }

    @Input()
    public task: ITaskModel;

    statusFormatter(calculationStatusCode: number) {
        return getPrettyPropertyRecordCalculationStatus(calculationStatusCode);
    }
}
